import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;



export const Container = styled.div`
  position: relative;
  background: transparent;
  border-top: 1px solid ${(p) => p.theme.colors.backgroundLight}30;
  margin-top: auto;
  padding: 0.5rem;
`;

export const ProfileButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: transparent;
  border: none;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(p) => p.theme.colors.backgroundLight}30;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const Avatar = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    ${(p) => p.theme.colors.primary} 0%,
    ${(p) => p.theme.colors.primary || p.theme.colors.primaryDark} 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(p) => p.theme.colors.onPrimary};
  font-size: 1rem;
  font-weight: 600;
  box-shadow: 0 2px 8px ${(p) => p.theme.colors.primary}40;
  transition: all 0.2s ease;

  ${ProfileButton}:hover & {
    transform: scale(1.05);
    box-shadow: 0 4px 12px ${(p) => p.theme.colors.primary}50;
  }
`;

export const UserInfo = styled.div`
  flex: 1;
  min-width: 0;
  text-align: left;
`;

export const UserName = styled.p`
  font-size: 0.9rem;
  font-weight: 600;
  color: ${(p) => p.theme.colors.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  line-height: 1.3;
`;

export const UserEmail = styled.p`
  font-size: 0.75rem;
  color: ${(p) => p.theme.colors.textLight};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  margin-top: 0.125rem;
`;

export const SettingsIcon = styled.div`
  color: ${(p) => p.theme.colors.textLight};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  background: transparent;

  ${ProfileButton}:hover & {
    color: ${(p) => p.theme.colors.primary};
    background: ${(p) => p.theme.colors.primary}15;
    transform: rotate(45deg);
  }
`;

export const MenuOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
  animation: fadeIn 0.15s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const Menu = styled.div`
  position: absolute;
  bottom: calc(100% + 0.5rem);
  left: 0.5rem;
  right: 0.5rem;
  background: ${(p) => p.theme.colors.surface};
  border: 1px solid ${(p) => p.theme.colors.backgroundLight}50;
  border-radius: 0.75rem;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 10px 20px -5px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  padding: 0.5rem;
  z-index: 101;
  animation: ${slideUp} 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  /* Borda de brilho no topo */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      ${(p) => p.theme.colors.backgroundLight}50,
      transparent
    );
  }
`;

export const MenuSection = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid ${(p) => p.theme.colors.backgroundLight}30;
    padding-bottom: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const MenuLabel = styled.p`
  font-size: 0.65rem;
  color: ${(p) => p.theme.colors.textLight};
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  margin: 0;
`;

export const MenuItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  background: transparent;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  color: ${(p) => p.theme.colors.text};
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease;
  text-align: left;

  &:hover {
    background: ${(p) => p.theme.colors.backgroundLight}40;
    transform: translateX(2px);
  }

  &:active {
    transform: scale(0.98);
  }

  svg {
    color: ${(p) => p.theme.colors.textLight};
    flex-shrink: 0;
    transition: color 0.15s ease;
  }

  &:hover svg {
    color: ${(p) => p.theme.colors.primary};
  }
`;

export const MenuItemDanger = styled(MenuItem)`
  color: ${(p) => p.theme.colors.negative || '#dc2626'};

  svg {
    color: ${(p) => p.theme.colors.negative || '#dc2626'};
  }

  &:hover {
    background: ${(p) => p.theme.colors.negative}15;

    svg {
      color: ${(p) => p.theme.colors.negative || '#dc2626'};
    }
  }
`;

export const ThemeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;



export const AvatarWrapper = styled.div`
  position: relative;
`;
